/**
 * Kenzis — scripts partagés (assets/kenzis.js)
 * - Révélation vidéo externe au clic
 * - Ajout au panier des cartes d'offre (#offre)
 * - Sticky CTA mobile (apparition après le hero)
 * - Stubs d'événements de tracking (dataLayer) : view_item, click_cta, add_to_cart,
 *   begin_checkout, purchase, click_whatsapp, click_video, select_offer_duo,
 *   submit_contact_form
 *
 * Aucune dépendance externe. Aucun tracking n'est envoyé sans configuration
 * réelle d'un gestionnaire de balises (GTM) ou d'un pixel côté marchand :
 * ces fonctions préparent uniquement window.dataLayer.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function kzTrack(eventName, payload) {
    try {
      window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    } catch (e) {
      /* silencieux : le tracking ne doit jamais casser l'UI */
    }
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- view_item automatique ---------- */
    document.querySelectorAll('[data-kz-track="view_item"]').forEach(function (el) {
      kzTrack('view_item', { product_id: el.getAttribute('data-kz-product-id') || null });
    });

    /* ---------- Clics CTA génériques ---------- */
    document.querySelectorAll('[data-kz-track="click_cta"]').forEach(function (el) {
      el.addEventListener('click', function () {
        kzTrack('click_cta', { cta_name: el.getAttribute('data-kz-event-name') || null });
      });
    });

    /* ---------- Vidéo : révélation au clic ---------- */
    document.querySelectorAll('[data-kz-video]').forEach(function (wrapper) {
      var playBtn = wrapper.querySelector('[data-kz-play]');
      if (!playBtn) return;
      playBtn.addEventListener('click', function () {
        var embed = wrapper.querySelector('[data-kz-embed]');
        var poster = wrapper.querySelector('.kz-howto__poster');
        var url = embed.getAttribute('data-url');
        var iframe = document.createElement('iframe');
        iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'autoplay; fullscreen';
        iframe.allowFullscreen = true;
        embed.appendChild(iframe);
        embed.hidden = false;
        if (poster) poster.style.display = 'none';
        playBtn.style.display = 'none';
        kzTrack('click_video');
      });
    });

    /* ---------- Offre : ajout au panier via /cart/add.js ---------- */
    document.querySelectorAll('[data-kz-add-to-cart]').forEach(function (btn) {
      var originalLabel = btn.textContent;
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        var offerLabel = btn.getAttribute('data-kz-offer');
        var statusEl = btn.closest('.kz-offer') ? btn.closest('.kz-offer').querySelector('[data-kz-offer-status]') : null;

        btn.disabled = true;
        btn.textContent = 'Ajout en cours…';

        kzTrack('select_offer_duo', { offer: offerLabel });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) { throw new Error('add-to-cart-failed'); }
            return res.json();
          })
          .then(function () {
            kzTrack('add_to_cart', { variant_id: variantId, offer: offerLabel });
            kzTrack('begin_checkout');
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
            if (statusEl) {
              statusEl.hidden = false;
              statusEl.textContent = 'Une erreur est survenue, veuillez réessayer.';
            }
          });
      });
    });

    /* ---------- Formulaire produit natif (fiche produit) ---------- */
    document.querySelectorAll('.kz-buybox form[action^="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('[data-kz-track="add_to_cart"]');
        kzTrack('add_to_cart');
        if (submitBtn && submitBtn.getAttribute('data-kz-then-checkout') === 'true') {
          kzTrack('begin_checkout');
        }
      });
    });

    /* ---------- Clics WhatsApp ---------- */
    document.querySelectorAll('[data-kz-whatsapp]').forEach(function (el) {
      el.addEventListener('click', function () {
        kzTrack('click_whatsapp');
      });
    });

    /* ---------- Formulaire de contact ---------- */
    document.querySelectorAll('[data-kz-contact-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        kzTrack('submit_contact_form');
      });
    });

    /* ---------- Sticky CTA mobile : apparition après le hero ---------- */
    var stickyBar = document.querySelector('[data-kz-sticky]');
    var heroEl = document.querySelector('.kz-hero');
    if (stickyBar && heroEl && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(heroEl);
    }
  });
})();
